(ns ycweb.app.website.banner.banner
  (:require
   [ajax.core :as ajax]
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defmethod comms/receive :web.footer/save-banner-click [app-atom {:keys [url-redirect]}]
  (swap! app-atom assoc-in [:redirect :uri] url-redirect)
  ;; TODO: replace with raw-redirect
  (urlstate/redirect! url-redirect))

(defmethod grid/action :web.footer/save-banner-click [app-atom {:keys [banner]} _]
  (let [mobile? (cmn/curact app-atom [:mobile?])
        user-id (cmn/curact app-atom [:user :refid])]
    (comms/ajax-post :web.footer/save-banner-click
      {:id (:contentid banner)
       :clid (:clid banner)
       :user-id user-id
       :mobile? mobile?
       :referrer (urlstate/current-url)
       :reference "footerads"})))

(rum/defc single-banner-ad < rum/reactive [app-atom banner options]
  (let [{:keys [url desktop_public_id name]} banner]
    [:div
     {:class (u/bem :flex-grid-block [:t-1-2 :s-1-4])}
     [:div.flex-grid-content
      [:article.footer-banner
       [:a.block-link
        {:href url
         :rel "nofollow"
         :on-click
         (fn [e]
           (.preventDefault e)
           (grid/dispatch-action app-atom :web.footer/save-banner-click {:banner banner}))}
        [:img
         {:class (u/bem :yc-simple-image [:full])
          :src
          (u/cloudinary
            desktop_public_id
            {:h 235
             :w 235
             :q "auto"
             :f "auto"}) :alt name}]]]]]))

(rum/defc footer-banner-ads
  < rum/reactive
  {:did-mount
   (fn [state]
     (let [[app-atom options] (:rum/args state)]
       #?(:cljs (grid/dispatch-action app-atom :web.footer/banners options)))
     state)}
  [app-atom options]
  (let [process-atom (cmn/process-cursor app-atom)
        banners (cmn/curact process-atom :banners)]
    [:aside
     {:class (u/bem :yc-section [:standard])}
     [:div.flex-grid-group
      (map
        (fn [b]
          (single-banner-ad app-atom b options))
        banners)]]))

(defmethod grid/action :web.footer/banners [app-atom {:keys [banner-type banner-limit reference]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        mobile? (cmn/curact app-atom [:mobile?])
        data
        (u/maybe assoc
          {:page (str "/" (cmn/page-base-url app-atom) ".htm")
           :banner-type banner-type}
          :limit banner-limit
          :mobile? mobile?
          :reference reference)]

    (ajax/GET "/api/banners/list-banners"
      {:response-format :json
       :format :json
       :params data
       :headers {"Accept" "application/json"}
       :keywords? true
       :handler
       (fn [{:keys [banners]}]
         (swap! process-atom assoc :banners banners))})))